export default "__VITE_ASSET__bb3cdaba__"